import useSubscriptionQuery from 'api/queries/useSubscriptionQuery';

export default function useInactiveSubscription() {
    const { data: subscription = {} } = useSubscriptionQuery();
    const inactiveSubscription = subscription?.status === 'CANCELLED' || subscription?.status === 'PAUSED';

    return inactiveSubscription;
}
